import { NewTooltip } from '@lib/components'
import {
  Question as QuestionIcon,
  WordpressLogo,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsWP } from '@/hooks'
import { ExportItem } from '../ExportItem'
import css from './styles.module.css'

export const ExportWp: React.FC = () => {
  const onClick = useExportAsWP(true)

  return (
    <ExportItem
      label="WordPress"
      exportable
      icon={WordpressLogo}
      onClick={onClick}
    >
      <NewTooltip
        content="More info"
        offset={{ y: 12 }}
        renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
          <a
            ref={onSetRef}
            className={css.item_hint}
            href="https://help.octopus.do/article/152-export-to-wordpress"
            target="_blank"
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            rel="noopener"
          >
            <QuestionIcon className={css.icon} />
          </a>
        )}
      />
    </ExportItem>
  )
}
